import React from 'react';
import { isEqual, startsWith } from 'lodash';
import { withUser } from '@client/decorators/Owner/withUser';
import { withSelectedProfile } from '@client/decorators/Owner/withSelectedProfile';
import { AnalyticsEvents } from '@sda/interfaces/queue/analytics';
import { Analytics } from '../Analytics';
import { Facebook } from './Facebook';
import { Kissmetrics } from './Kissmetrics';
import { Intercom } from './Intercom';
import { WidthLoader } from './WidthLoader';
import { Hotjar } from './Hotjar';

@withUser({ flatten: true })
@withSelectedProfile({ flatten: true })
export class AnalyticsLoader extends React.PureComponent {
  componentDidMount() {
    const {
      user, profile, anonymous, acceptsCookies,
    } = this.props;

    if (user
      && user.publicFetched
      && user.privateFetched
      && acceptsCookies) {
      Analytics.setIdentity(user);
      Analytics.updateUser(user, profile);
    }

    if (anonymous && acceptsCookies) {
      Analytics.setIdentity(anonymous);
      Analytics.updateUser(anonymous);
    }
  }

  componentDidUpdate(prevProps) {
    const {
      user, path, scaffolded, anonymous,
      acceptsCookies, profile,
    } = this.props;

    const freshlyScaffolded = scaffolded && !prevProps?.scaffolded;

    /**
     * Update the identity if there is a new user
     */
    if (user && acceptsCookies && (!isEqual(user, prevProps?.user) || freshlyScaffolded)) {
      if (user.uid !== prevProps?.user?.uid || freshlyScaffolded) {
        Analytics.setIdentity(user);
      }

      if (user.privateFetched && user.publicFetched) {
        Analytics.updateUser(user, profile);
      }
    }

    if (anonymous && acceptsCookies && (!isEqual(anonymous, prevProps?.anonymous) || freshlyScaffolded)) {
      Analytics.setIdentity(anonymous);
      Analytics.updateUser(anonymous);
    }

    /**
     * Send view paged event when the user's path location updates
     */
    if (path !== prevProps?.path || freshlyScaffolded) {
      Analytics.track(AnalyticsEvents.VIEWED_PAGE, {
        currentPath: path,
        previousPath: prevProps.path,
      });
    }
  }

  componentWillUnmount() {
    const { user } = this.props;

    Analytics.clearIdentity(user || null);
  }

  render() {
    const {
      user, hasIntercom, acceptsCookies, path,
      showIntercom, profile, hasLeftAlignedIntercom, hideLauncher,
    } = this.props;

    if (user && user.isAdmin) {
      return null;
    }

    return (
      <>
        {Boolean(hasIntercom) && (
          <WidthLoader>
            {(isMobile) => (
              <Intercom
                showIntercom={showIntercom}
                isMobile={isMobile}
                hasProfile={Boolean(profile)}
                hasLeftAlignedIntercom={hasLeftAlignedIntercom}
                hideLauncher={hideLauncher}
              />
            )}
          </WidthLoader>
        )}

        <Kissmetrics />

        <Facebook acceptsCookies={acceptsCookies} />

        {process.env.NODE_ENV !== 'development' && startsWith(path, '/signup') && (
          <Hotjar />
        )}
      </>
    );
  }
}
